import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const TEAMS_LIST = "teams_list";
export const CREATE_TEAMS = "create_teams";
export const UPDATE_TEAMS = "update_teams";
export const DELETE_TEAMS = "delete_teams";
export const GET_TEAMS_DETAILS = "get_teams_details";
export const TEAMS_SIMPLE_LIST = "teams_simple_list";
export const TEAMS_SIMPLE_FULL_LIST = "teams_simple_full_list";
export const CLEAR_TEAMS_ERRORS = "clearTeamsErrors";

// mutation types
export const SET_TEAMS_ERROR = "setTeamsErrors";
export const REMOVE_TEAMS_ERRORS = "removeTeamsErrors";

const state = {
    errors: null
};
const actions = {
    [TEAMS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/teams?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_TEAMS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_TEAMS_ERROR, response.errors);
                });
        });
    },
    [CREATE_TEAMS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createteam", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_TEAMS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_TEAMS_ERROR, response.errors);
                });
        });
    },
    [UPDATE_TEAMS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateteam", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_TEAMS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_TEAMS_ERROR, response.errors);
                });
        });
    },
    [DELETE_TEAMS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteteam", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_TEAMS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_TEAMS_ERROR, response.errors);
                });
        });
    },
    [GET_TEAMS_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getteamdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_TEAMS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_TEAMS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_TEAMS_ERRORS](context) {
        context.commit(REMOVE_TEAMS_ERRORS);
    },
    [TEAMS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/teamssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [TEAMS_SIMPLE_FULL_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/teamssimplefull")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
};

const mutations = {
    [SET_TEAMS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_TEAMS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
